import hasOverflow from '../../../../functions/has-overflow'
import throttle from 'lodash.throttle'

class NavigationStrip {
  /**
   * Create new strip nav
   * @param {HTMLElement} element Root strip nav element
   */
  constructor(element) {
    this.root = element
    this.container = element.querySelector('.js-navigation-strip-container')
    this.content = element.querySelector('.js-navigation-strip-content')
    this.activeLink = element.querySelector('.js-navigation-strip-link.is-active')

    this.setOverflowState()
    this.watchOverflow()

    if (this.activeLink) {
      this.centerActiveLink()
    }
  }

  centerActiveLink() {
    const linkLeft = this.activeLink.offsetLeft
    const linkWidth = this.activeLink.clientWidth
    const containerWidth = this.container.clientWidth

    this.container.scrollLeft = linkLeft - (containerWidth - linkWidth) / 2
  }

  setOverflowState() {
    const overflow = hasOverflow(this.container, this.content)

    if (overflow.left) {
      this.root.classList.add('has-overflow-left')
    } else {
      this.root.classList.remove('has-overflow-left')
    }

    if (overflow.right) {
      this.root.classList.add('has-overflow-right')
    } else {
      this.root.classList.remove('has-overflow-right')
    }
  }

  watchOverflow() {
    this.container.addEventListener('scroll', throttle(() => this.setOverflowState(), 100))
  }
}

window.addEventListener('load', () => {
  for (const nav of document.querySelectorAll('.js-navigation-strip')) {
    // eslint-disable-next-line no-new
    new NavigationStrip(nav)
  }
})
